module.exports = __webpack_public_path__ + "84b4349f71ec70698d65a82c7abb661a.pdf";